import Link from 'next/link';
import { PageUrl } from '../../../constants/PageUrl';
import styles from './index.module.scss';

type Props = {
  title: string;
};

export const Breadcrumb = ({ title }: Props) => (
  <nav aria-label="パンくずリスト" className={styles.base}>
    <ol className={styles.list}>
      <li className={styles.item}>
        <Link href={PageUrl.TOP}>ホーム</Link>
      </li>
      <li className={styles.item}>
        <Link href={PageUrl.BLOG_ROOT}>ブログ</Link>
      </li>
      <li className={styles.item} aria-current="page">
        {title}
      </li>
    </ol>
  </nav>
);
